<template>
  <van-popup
    class="logistics-form-dialog"
    :value="show"
    :close-on-click-overlay="false"
    @input="onUpdateShow"
  >
    <div class="dialog-content">
      <!-- 头部 -->
      <div class="dialog-header">
        <div class="header-left"></div>
        <div class="header-title">
          <div class="title-text">请填写物流单号</div>
        </div>
        <div class="header-right">
          <div class="close-btn" @click="handleClose">
            <img src="@/assets/icons/closer.svg" alt="" />
          </div>
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="content-area">
        <!-- 物流类型选择 -->
        <div class="form-group">
          <div class="form-label">
            <span class="label-text">物流类型</span>
            <span class="icon-required">*</span>
          </div>
          <div class="form-input">
            <van-field
              :value="selectedLogisticsTypeLabel"
              readonly
              placeholder="请选择"
              @click="showLogisticsTypePicker = true"
            />
            <div class="dropdown-icon">
              <img src="@/assets/icons/drop-down.svg" alt="" />
            </div>
            <!-- 物流类型选择器 -->
            <div class="dropdown-content" v-if="showLogisticsTypePicker">
              <div class="dropdown-list">
                <div
                  v-for="(option, index) in logisticsTypeOptions"
                  :key="index"
                  class="dropdown-item"
                  :class="{ active: logisticsType === option.value }"
                  @click="onLogisticsTypeConfirm(option.value)"
                >
                  <div class="dropdown-item-text">{{ option.label }}</div>
                  <div
                    v-if="logisticsType === option.value"
                    class="dropdown-item-check"
                  >
                    <img src="@/assets/icons/checked.svg" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 物流单号输入 -->
        <div class="form-group">
          <div class="form-label">
            <span class="label-text">物流单号</span>
            <span class="icon-required">*</span>
          </div>
          <div class="form-input">
            <van-field
              v-model="logisticsNumber"
              placeholder="请输入或扫描物流单号"
              clearable
            />
            <div class="scan-icon" @click="handleScan">
              <img src="@/assets/icons/scan-code.svg" />
            </div>
          </div>
        </div>
      </div>

      <!-- 按钮区域 -->
      <div class="dialog-buttons">
        <van-button class="btn-primary" type="primary" @click="handleConfirm">
          确定
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
  export default {
    name: 'LogisticsFormDialog',
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        logisticsType: '',
        logisticsNumber: '',
        showLogisticsTypePicker: false,
        logisticsTypeOptions: [
          { value: 'SF', label: '顺丰速运' },
          { value: 'SFTC', label: '顺丰同城' },
          { value: 'JD', label: '京东速度' },
          { value: 'EMS', label: 'EMS速递' },
          { value: 'ZTO', label: '中通快递' },
          { value: 'STO', label: '申通快递' },
          { value: 'YTO', label: '圆通快递' },
          { value: 'YUNDA', label: '韵达快递' },
          { value: 'JTSD', label: '极兔速递' },
          { value: 'KUAYUE', label: '跨越速运' },
          { value: 'FENGNIAO', label: '蜂鸟同城' },
          { value: 'DADA', label: '达达同城' },
          { value: 'JDTC', label: '京东同城' },
          { value: 'MTPS', label: '美团配送' }
        ]
      }
    },
    computed: {
      selectedLogisticsTypeLabel() {
        const selectedOption = this.logisticsTypeOptions.find(
          option => option.value === this.logisticsType
        )
        return selectedOption ? selectedOption.label : ''
      }
    },
    methods: {
      onUpdateShow(value) {
        this.$emit('update:show', value)
      },
      handleClose() {
        this.$emit('update:show', false)
        this.$emit('close')
      },
      handleConfirm() {
        if (!this.logisticsType) {
          this.$toast('请选择物流类型')
          return
        }
        if (!this.logisticsNumber) {
          this.$toast('请输入物流单号')
          return
        }

        this.$emit('confirm', {
          logisticsType: this.logisticsType,
          logisticsNumber: this.logisticsNumber
        })
        this.handleClose()
      },
      onLogisticsTypeConfirm(value) {
        this.logisticsType = value
        this.showLogisticsTypePicker = false
      },
      handleScan() {
        wx.scanQRCode({
          needResult: 1,
          desc: '物流单号',
          scanType: ['qrCode', 'barCode'],
          success: res => {
            console.log('order scan res', res)
            if (res.errMsg === 'scanQRCode:ok') {
              if (res.resultStr) {
                this.logisticsNumber = res.resultStr
              }
            } else {
              console.log('order scan notOk', res.errMsg)
            }
          },
          fail: function (err) {
            console.error('order scan fail', err)
            if (err.errMsg.indexOf('function_not_exist') > 0) {
              this.$toast('版本过低请升级')
            }
          },
          error: function (err) {
            console.error('order scan error', err)
            if (err.errMsg.indexOf('function_not_exist') > 0) {
              this.$toast('版本过低请升级')
            }
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .logistics-form-dialog {
    width: 320/20rem;
    background: #ffffff;
    border-radius: 10/20rem;
    overflow: hidden;

    .dialog-content {
      padding: 0;
    }
  }

  .dialog-header {
    display: flex;
    align-items: center;
    padding: 10/20rem 10/20rem 6/20rem;
    height: 38/20rem;

    .header-left {
      width: 22/20rem;
    }

    .header-title {
      flex: 1;
      height: 22/20rem;
      display: flex;
      justify-content: center;
      align-items: center;

      .title-text {
        font-family: 'PingFang SC', sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 1.25;
        color: #000000;
        text-align: center;
      }
    }

    .header-right {
      width: 22/20rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .close-btn {
      width: 22/20rem;
      height: 22/20rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }

      &:hover {
        opacity: 0.7;
      }
    }
  }

  .content-area {
    padding: 0 20/20rem 20/20rem;
    display: flex;
    flex-direction: column;
    gap: 13/20rem;

    .form-group {
      display: flex;
      flex-direction: column;
      gap: 10/20rem;

      .form-label {
        display: flex;
        align-items: center;
        gap: 6/20rem;

        .label-text {
          font-family: 'PingFang SC', sans-serif;
          font-size: 12px;
          font-weight: 400;
          line-height: 1.4;
          color: #5e5e5e;
        }

        .icon-required {
          font-size: 12px;
          color: #ff4242;
        }
      }

      .form-input {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;

        :deep(.van-cell) {
          width: 100%;
          background: #fbfbfb;
          border: 1px solid #c7c9cc;
          width: 280/20rem;
          height: 40/20rem;
          padding: 0 10/20rem !important;

          .van-field__control {
            font-family: 'PingFang SC', sans-serif;
            font-size: 14px;
            font-weight: 400;
            color: #a7a7a7;
            width: 100%;
            height: 100%;
          }

          .van-field__body {
            width: 100%;
            height: 100%;
          }
        }

        .dropdown-icon,
        .scan-icon {
          position: absolute;
          right: 10/20rem;
          top: 50%;
          transform: translateY(-50%);
          width: 22/20rem;
          height: 22/20rem;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          &:hover {
            opacity: 0.7;
          }
        }

        .scan-icon {
          right: 10/20rem;
        }

        // 物流类型下拉框样式
        .dropdown-content {
          position: absolute;
          top: 50/20rem;
          left: 0;
          right: 0;
          z-index: 9999;
          background: #ffffff;
          max-height: 150/20rem;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          border: 1px solid #c7c9cc;

          .dropdown-list {
            flex: 1;
            overflow-y: auto;

            .dropdown-item {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 12/20rem 16/20rem;
              font-family: 'PingFang SC', sans-serif;
              font-size: 14px;
              font-weight: 400;
              color: #000000;
              border-bottom: 1px solid #f5f5f5;
              cursor: pointer;
              min-height: 40/20rem;

              &:last-child {
                border-bottom: none;
              }

              &:hover {
                background-color: #f8f8f8;
              }

              &.active {
                color: #000000;
                background-color: #f0f0f0;
                font-weight: 500;
              }

              .dropdown-item-text {
                flex: 1;
              }

              .dropdown-item-check {
                width: 22/20rem;
                height: 22/20rem;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                  width: 16/20rem;
                  height: 16/20rem;
                }
              }
            }
          }
        }
      }
    }
  }

  .dialog-buttons {
    display: flex;
    gap: 12/20rem;
    padding: 16/20rem 20/20rem 20/20rem;

    .btn-primary {
      flex: 1;
      height: 38/20rem;
      border-radius: 4/20rem;
      font-family: 'SF Pro', 'PingFang SC', sans-serif;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.714;
      background: #000000;
      color: #ffffff;

      &:hover {
        opacity: 0.8;
      }

      &:active {
        opacity: 0.6;
      }
    }
  }
</style>
